export default __webpack_public_path__ + "img/0be2550556d35f50c3eabdd72a1c9ad0.png";